import * as React from 'react'
import Img from 'gatsby-image'
import { IImageProps, FixedImageType, FluidImageType } from './Image.types'

const Image = ({ alt, className, fixed, image }: IImageProps) => {
  if (typeof image === 'string') {
    return <img className={className} src={image} alt={alt} />
  } else {
    if (image?.childImageSharp) {
      return fixed ? (
        <Img fixed={(image.childImageSharp as FixedImageType).fixed} className={className} alt={alt} />
      ) : (
        <Img fluid={(image.childImageSharp as FluidImageType).fluid} className={className} alt={alt} />
      )
    }

    if (image?.publicURL) {
      return <img src={image.publicURL} className={className} alt={alt} />
    }
  }
  return null
}

export default Image
